import { render, staticRenderFns } from "./HoriScroll.vue?vue&type=template&id=38eaa884&scoped=true"
import script from "./HoriScroll.vue?vue&type=script&lang=ts"
export * from "./HoriScroll.vue?vue&type=script&lang=ts"
import style0 from "./HoriScroll.vue?vue&type=style&index=0&id=38eaa884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eaa884",
  null
  
)

export default component.exports